import React from 'react';
import { Button } from '../components/ui/button';
import { ArrowLeft } from 'lucide-react';
import { useNavigate } from 'react-router-dom';

const PrivacyPolicy = () => {
  const navigate = useNavigate();
  const currentDate = new Date().toLocaleDateString('es-MX', { year: 'numeric', month: 'long', day: 'numeric' });

  return (
    <div className="min-h-screen bg-gray-50">
      <div className="max-w-4xl mx-auto px-4 py-8">
        <Button
          variant="ghost"
          onClick={() => navigate(-1)}
          className="mb-6"
        >
          <ArrowLeft className="w-4 h-4 mr-2" />
          Volver
        </Button>

        <div className="bg-white rounded-lg shadow-lg p-6 md:p-10">
          <h1 className="text-3xl font-bold text-gray-900 mb-2">Política de Privacidad</h1>
          <p className="text-gray-500 mb-8">Última actualización: {currentDate}</p>

          <div className="space-y-6 text-gray-700">
            <section>
              <h2 className="text-xl font-semibold text-gray-900 mb-3">1. Datos que Capturamos</h2>
              <p className="mb-3">En NotiMax capturamos los siguientes datos para el funcionamiento del servicio:</p>
              <ul className="list-disc pl-6 space-y-2">
                <li><strong>Datos de cuenta:</strong> Nombre, correo electrónico y contraseña para acceder a tu cuenta.</li>
                <li><strong>Datos de tu negocio:</strong> Nombre del negocio, teléfono y logo (opcional) para personalizar tu perfil.</li>
                <li><strong>Datos de citas:</strong> Nombre de tus clientes, números de teléfono, fechas y horarios de citas.</li>
                <li><strong>Notas y recomendaciones:</strong> Información que agregas sobre tus clientes para tu referencia.</li>
              </ul>
            </section>

            <section>
              <h2 className="text-xl font-semibold text-gray-900 mb-3">2. Para qué Usamos tus Datos</h2>
              <p className="mb-3">Tus datos se utilizan únicamente para:</p>
              <ul className="list-disc pl-6 space-y-2">
                <li>Permitirte gestionar tus citas y agenda.</li>
                <li>Enviar recordatorios a tus clientes (cuando tú lo solicites).</li>
                <li>Mostrarte estadísticas de tu negocio.</li>
                <li>Procesar tu suscripción de forma segura.</li>
              </ul>
            </section>

            <section className="bg-green-50 p-4 rounded-lg border border-green-200">
              <h2 className="text-xl font-semibold text-green-800 mb-3">3. Tus Datos NO se Comparten</h2>
              <p className="text-green-800">
                <strong>Tus datos son solo tuyos.</strong> No vendemos, alquilamos ni compartimos tu información con terceros. 
                Toda la información que ingresas se guarda exclusivamente para tu uso personal y el de tu negocio.
              </p>
            </section>

            <section>
              <h2 className="text-xl font-semibold text-gray-900 mb-3">4. Seguridad</h2>
              <p>Protegemos tus datos con:</p>
              <ul className="list-disc pl-6 space-y-2 mt-3">
                <li>Conexión segura (HTTPS) en todo momento.</li>
                <li>Contraseñas encriptadas.</li>
                <li>Acceso restringido solo a tu cuenta.</li>
              </ul>
            </section>

            <section>
              <h2 className="text-xl font-semibold text-gray-900 mb-3">5. Tus Derechos</h2>
              <p className="mb-3">Puedes en cualquier momento:</p>
              <ul className="list-disc pl-6 space-y-2">
                <li>Acceder a toda tu información.</li>
                <li>Descargar un respaldo de tus datos.</li>
                <li>Solicitar la eliminación de tu cuenta y datos.</li>
              </ul>
            </section>

            <section>
              <h2 className="text-xl font-semibold text-gray-900 mb-3">6. Contacto</h2>
              <p>Si tienes preguntas sobre esta política, contáctanos en:</p>
              <p className="mt-2"><strong>Email:</strong> soporte@notimax.app</p>
            </section>
          </div>

          <div className="mt-10 pt-6 border-t border-gray-200 text-center text-gray-500 text-sm">
            <p>© {new Date().getFullYear()} NotiMax. Todos los derechos reservados.</p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PrivacyPolicy;
